import React, { useState } from 'react';
import { SectionParagraph, SectionTitle, SectionWrapper } from '../styles';
import { useTranslation } from 'next-i18next';

const Algorithm: React.FC = () => {
  const { t } = useTranslation();
  return (
    <SectionWrapper>
      <SectionTitle>{t('ALGORITHM')}</SectionTitle>
      <SectionParagraph>
        {t(
          'Before the first round of the game began, we created a chain of hashes. Each hash is a 256 bit value. The chain begins with a randomly chosen 256 bit value and every subsequent value is calculated using the',
        )}
      </SectionParagraph>
      <SectionParagraph>
        {t(
          'Using a cryptographic hash function ensures that one can easily calculate any value in the chain using the previous value, but one can not easily calculate values in the reverse direction. The last value in the precalculated hash chain is what we publically published and used for the first round of the game. The second round of the game used the second to last hash value, the third round used the third to last hash value, etc. By traversing the chain in this manner, one can verify that the outcome of all past game rounds were consistent with the precalculated chain, but the outcome of future rounds remains unpredictable to users.',
        )}
      </SectionParagraph>
      <SectionParagraph>
        {t(
          'In order to eliminate the possibility that we intentionally generated the chain using an initial value that biased the games results in our favor, each value in the chain is appended to the global seed and the resulting value is hashed again using BLAKE2b to create the final value that will determine the outcome of each game round. This global seed is set to the hash of the Bitcoin block that we announced prior to its mining. The inclusion of the global seed ensures that the outcome of the games was unknowable to us when the hash value of the first game was published.',
        )}
      </SectionParagraph>
    </SectionWrapper>
  );
};

export default Algorithm;
